


















































































import { Vue, Prop, Component } from "vue-property-decorator";
import { TestPass as ITestPass } from "@/api/models/test-pass";
import { User as IUser } from "@/api/models/user";
import moment from "moment";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class TestResultsTable extends Vue {
  @Prop() testPass!: ITestPass;
  user!: IUser;
  finishedAt?: Date = this.testPass.finishedAt;
  data() {
    return {
      user: undefined
    };
  }

  get checkTypeTest() {
    return this.testPass.targetType === "course" ? "course" : "lecture";
  }

  get passed() {
    return this.testPass.passedAt
      ? moment(this.testPass.passedAt).format("lll")
      : this.$tc(this.$translate.NotComplete);
  }
}
